export default "/_next/static/images/878c61fe9c1d6e8d260d668c363500b0.png";